module.exports = __webpack_public_path__ + "img/slika61.0c0d44f6.jpg";